import React from "react";
import { Link } from "react-router-dom";
import { siteConfig } from "../Datas/productData";
import "../css/footer.scss";

const shopPath = (item) =>
  item.category
    ? `/shop?category=${encodeURIComponent(item.category)}`
    : `/shop?tag=${encodeURIComponent(item.tag)}`;

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="site-footer__inner">
        <div className="site-footer__directory">
          <div className="site-footer__identity">
            <Link className="site-footer__wordmark" to="/">
              {siteConfig.brandName}
            </Link>
            <p>{siteConfig.description}</p>
          </div>
          <div className="site-footer__link-columns">
            <nav className="site-footer__column" aria-label="Shop links">
              <h3>Shop</h3>
              <ul>
                <li><Link to="/shop">Shop all</Link></li>
                {siteConfig.navigation.slice(0, 5).map((item) => (
                  <li key={item.label}><Link to={shopPath(item)}>{item.label}</Link></li>
                ))}
              </ul>
            </nav>
            <nav className="site-footer__column" aria-label="Customer care links">
              <h3>Here to help</h3>
              <ul>
                <li><Link to="/about">About us</Link></li>
                <li><Link to="/shipping">Delivery</Link></li>
                <li><Link to="/returns">Returns</Link></li>
                <li><Link to="/contact">Contact</Link></li>
                <li><Link to="/faqs">FAQs</Link></li>
              </ul>
            </nav>
            <nav className="site-footer__column" aria-label="Legal and policy links">
              <h3>Legal &amp; policies</h3>
              <ul>
                <li><Link to="/policies">Policy centre</Link></li>
                <li><Link to="/privacy">Privacy policy</Link></li>
                <li><Link to="/cookies">Cookie policy</Link></li>
                <li><Link to="/terms">Terms &amp; conditions</Link></li>
                <li><Link to="/policies/refunds">Refund policy</Link></li>
                <li><Link to="/policies/cancellations">Cancellations</Link></li>
                <li><Link to="/policies/accessibility">Accessibility</Link></li>
              </ul>
            </nav>
            <div className="site-footer__column site-footer__contact">
              <h3>Contact</h3>
              <address>
                <a href={`mailto:${siteConfig.contact.email}`}>{siteConfig.contact.email}</a>
                <span>{siteConfig.contact.hours}</span>
                <span>{siteConfig.contact.address}</span>
              </address>
            </div>
          </div>
        </div>
        <div className="site-footer__payments" aria-label="Supported payment methods">
          <strong>Secure payments</strong>
          <span>Visa</span>
          <span>Mastercard</span>
          <span>American Express</span>
          <span>UnionPay</span>
        </div>
        <div className="site-footer__bottom">
          <p>Hong Kong&nbsp; / &nbsp;{siteConfig.currency.code} ({siteConfig.currency.symbol})</p>
          <p>&copy; {new Date().getFullYear()} {siteConfig.legalName}</p>
        </div>
      </div>
    </footer>
  );
}
